import {ActionReducerMap, createReducer, on} from "@ngrx/store";
import {CoreActions} from "@core/store/core.actions";

export const STATE_KEY_CORE = 'core';

export interface CoreState {
  isOnline: boolean;
}

const initialState: CoreState = {
  isOnline: true
}

const coreReducer = createReducer(
  initialState,
  on(
    CoreActions.setIsOnline,
    (state, {isOnline}) => {
      return {
        ...state,
        isOnline
      }
    }
  )
)

export const coreReducers: ActionReducerMap<any> = {
  [STATE_KEY_CORE] : coreReducer
}
